import { useTranslation } from "react-i18next";
import { SpeechLanguage } from "../types/audio";

export function useVoiceLanguage(): SpeechLanguage {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").toLowerCase().split("-")[0];
  return lang === "fr" ? "fr" : "en";
}
